import { defineStore } from 'pinia'

// Persistimos o projeto em edição no localStorage para o modo-edição sobreviver ao F5/reload.
// Só é limpo quando o integrador salva o equipamento (stopEditingEquipment) ou explicitamente reseta.
const STORAGE_KEY = 'equipment-edit-project-id'

function readStoredProjectId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  }
  catch {
    return null
  }
}

function persistProjectId(projectId: string) {
  try {
    localStorage.setItem(STORAGE_KEY, projectId)
  }
  catch {}
}

function clearStoredProjectId() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  }
  catch {}
}

export const useEquipmentEditStore = defineStore('equipmentEdit', () => {
  const storedProjectId = readStoredProjectId()
  const isEditingEquipment = ref(storedProjectId !== null)
  const projectIdBeingEdited = ref<string | null>(storedProjectId)

  function startEditingEquipment(projectId: string) {
    isEditingEquipment.value = true
    projectIdBeingEdited.value = projectId
    persistProjectId(projectId)
  }

  function stopEditingEquipment() {
    isEditingEquipment.value = false
    projectIdBeingEdited.value = null
    clearStoredProjectId()
  }

  function isProjectBeingEdited(projectId: string): boolean {
    return isEditingEquipment.value && projectIdBeingEdited.value === projectId
  }

  function resetEditingState() {
    isEditingEquipment.value = false
    projectIdBeingEdited.value = null
    clearStoredProjectId()
  }

  return {
    isEditingEquipment,
    projectIdBeingEdited,
    startEditingEquipment,
    stopEditingEquipment,
    isProjectBeingEdited,
    resetEditingState,
  }
})
